import React, { useEffect, useState } from 'react';
import { Formik, Form, Field } from 'formik';
import styles from './styles/viewUser.module.css';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import Avatar from '@mui/material/Avatar';

import {IndividualViewChart} from 'components/UI/Chart';
import { ReactComponent as OxygenIcon } from '../../utils/assets/Path.svg';
import { ReactComponent as AltitudeIcon } from '../../utils/assets/Path3.svg';
import { ReactComponent as AirQualityIcon } from '../../utils/assets/Path4.svg';
import { ReactComponent as HumidityIcon } from '../../utils/assets/path5.svg';
import { ReactComponent as BarometricIcon } from '../../utils/assets/path6.svg';
import { ReactComponent as HeartIcon } from '../../utils/assets/heart.svg';

// import { ReactComponent as TempatureIcon } from '../../utils/assets/temprature.svg';
// import { ReactComponent as PerfusionIcon } from '../../utils/assets/perfusion.svg';
// import { ReactComponent as HRRIcon } from '../../utils/assets/hrr.svg';
// import { ReactComponent as HRVIcon } from '../../utils/assets/HRV.svg';
// import { ReactComponent as SPOIcon } from '../../utils/assets/Vo2.svg';

import { useNavigate, useLocation } from 'react-router-dom';
import useAxiosPrivate from '../../utils/hooks/useAxiosPrivate';
import Jsonpack from 'jsonpack';
import { Button, Typography } from '@material-ui/core';
import InfoIcon from '@mui/icons-material/Info';
import { ReactComponent as EditIconTakeNote } from '../../utils/assets/editIcon_TakeNote.svg';
import AddPrivateNote from './add_private_note';
import useSSE from '../../utils/hooks/useSSE';
import { SingleVital } from './SingleVital';
import InsuranceStatementModal from '../dashboard/insuranceStatement/InsuranceStatementModal';
// import {Line} from "recharts";

const DaysUsedCheckIcon = ({ className }) => (
	<svg className={className} width="21" height="21" viewBox="0 0 21 21" fill="none">
		<circle cx="10.5" cy="10.5" r="9.25" stroke="#0C8092" strokeWidth="1.6" />
		<path
			d="M5.7 11.3L9 14.5L15.3 6.8"
			stroke="#0C8092"
			strokeWidth="1.8"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default function ViewUser() {
	const axios = useAxiosPrivate();
	let navigate = useNavigate();
	const location = useLocation();
	const item = location.state;

	// eslint-disable-next-line
	const [members, setMembers] = useState([]);
	// const [user, setUser] = useState([]);
	const [fData, setFData] = useState([]);
	const [fromDate, setFromDate] = useState('');
	const [open, setOpen] = useState(false);
	const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);
	const initialStartTime = React.useMemo(() => {
		const tenMinutesAgo = new Date(Date.now() - 10 * 60 * 1000);
		return tenMinutesAgo.toTimeString().split(' ')[0];
	}, []);
	const initialEndTime = React.useMemo(() => {
		const now = new Date();
		return now.toTimeString().split(' ')[0];
	}, []);

	// const [selectedDate, setSelectedDate] = useState("2025-06-08");
	// const initialStartTime = React.useMemo(() => {
	//
	// 	return "12:04:00"
	// }, []);
	// const initialEndTime = React.useMemo(() => {
	//
	// 	return "12:14:00";
	// }, []);

	const [userGraphData, setUserGraphData] = useState([]);
	const [isLoadingGraphData, setIsLoadingGraphData] = useState(false);
	const [graphDataError, setGraphDataError] = useState(null);

	const [insuranceStatement, setInsuranceStatement] = useState(null);
	const [insuranceModalOpen, setInsuranceModalOpen] = useState(false);
	const daysUsed = insuranceStatement?.used_days ?? 0;
	const totalDaysAllowed = insuranceStatement?.window_days ?? 30;
	const insuranceStatementPatient = {
		id: item.user_id,
		name: `${item?.first_name ?? ''} ${item?.last_name ?? ''}`.trim(),
		avatarUrl: item?.avatar_url,
		daysUsed: insuranceStatement?.days_used_display ?? `${daysUsed}/${totalDaysAllowed}`,
		usedDays: daysUsed,
		windowDays: totalDaysAllowed,
	};

    // const options = {
    //     responsive: true,
    //     maintainAspectRatio: false,
    //     interaction: {
    //         mode: "index",
    //         intersect: false,
    //     },
    //     plugins: {
    //         legend: {
    //             position: "top",
    //         },
    //         title: {
    //             display: true,
    //             text:
    //                 `6-Minute Walk and Recovery**`,
    //             font: {
    //                 family: "Poppins",
    //                 size: 14,
    //                 weight: "500",
    //             },
    //         },
    //     },
    //     scales: {
    //         x: {
    //             title: {
    //                 display: true,
    //                 text: "Time (Minutes)",
    //                 font: {
    //                     family: "Poppins",
    //                 },
    //             },
    //         },
    //         y: {
    //             type: "linear",
    //             display: true,
    //             position: "left",
    //             min: 40,
    //             max: 200,
    //             title: {
    //                 display: true,
    //                 text: "Pulse Rate (bpm)",
    //                 font: {
    //                     family: "Poppins",
    //                 },
    //             },
    //         },
    //         y1: {
    //             type: "linear",
    //             display: true,
    //             position: "right",
    //             min: 70,
    //             max: 100,
    //             title: {
    //                 display: true,
    //                 text: "SpO2 (%)",
    //                 font: {
    //                     family: "Poppins",
    //                 },
    //             },
    //             grid: {
    //                 drawOnChartArea: false,
    //             },
    //         },
    //     },
    // };

	const direct = () => {
		navigate('/dashboard');
	};

	function handleClick(event) {
		event.preventDefault();
		navigate('/dashboard');
	}

	
	const getData = async () => {
		if (fromDate === '') {
			const { data } = await axios.post('/team/data', {
				only_updates: false,
				user_ids: [item.user_id],
			});
			const json = Jsonpack.unpack(data.data);
			setFData(json);
			setInsuranceStatement(data.insurance_statement ?? null);

			const results = Object.entries(json)
				// eslint-disable-next-line
				.map((item) => {
					if (item[1].length) {
						if (item[1][item.length - 1]?.reading_time) {
							return new Date(item[1][item.length - 1].reading_time);
						}
					}
				})
				.filter((record) => record);

			if (results.length) {
				setFromDate(new Date(Math.max(...results)).toString());
			}
		} else if (fromDate !== '') {
			const { data } = await axios.post('/team/data', {
				only_updates: true,
				user_ids: [item.user_id],
				from_time: fromDate,
			});

			const json = Jsonpack.unpack(data.data);
			setFData(json);
			setInsuranceStatement(data.insurance_statement ?? null);

			const results = Object.entries(json)
				// eslint-disable-next-line
				.map((item) => {
					if (item[1].length) {
						if (item[1][item.length - 1]?.reading_time) {
							return new Date(item[1][item.length - 1].reading_time);
						}
					}
				})
				.filter((record) => record);

			if (results.length) {
				setFromDate(new Date(Math.min(...results)).toString());
			}
		}
	};

	const getIndividualDataGraphData = async (requestData) => {
		setIsLoadingGraphData(true);
		setGraphDataError(null);

		try {
			const { data } = await axios.get(
				`/user/data/${item.user_id}?date=${requestData.date}&from_time=${requestData.startTime}&to_time=${requestData.endTime}`
			);

			// Handle empty or invalid data
			if (data && data.data) {
				setUserGraphData(data.data);
			} else {
				setUserGraphData([]);
				setGraphDataError('No data available for the selected time range');
			}
		
		} catch (error) {
			console.error('Error fetching graph data:', error);
			setUserGraphData([]);
			setGraphDataError('Failed to load data. Please try again.');
		} finally {
			setIsLoadingGraphData(false);
		}
	}

	const timeStringToMinutes = (timeString) => {
		const [hours, minutes] = timeString.split(':').map(Number);
		return hours * 60 + minutes;
	};

	const minutesToTimeString = (minutes) => {
		// Handle negative minutes (before midnight)
		if (minutes < 0) {
			minutes = 24 * 60 + minutes; // Add 24 hours worth of minutes
		}
		// Handle minutes beyond 24 hours (after midnight)
		if (minutes >= 24 * 60) {
			minutes = minutes % (24 * 60); // Wrap around to next day
		}
		
		const hours = Math.floor(minutes / 60);
		const mins = minutes % 60;
		return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:00`;
	};

	const validateAndAdjustTimes = (startTime, endTime, changedField) => {
		const startMinutes = timeStringToMinutes(startTime);
		const endMinutes = timeStringToMinutes(endTime);
		
		// Handle edge case: if times are the same, add 1 minute to end time
		if (startMinutes === endMinutes) {
			if (changedField === 'startTime') {
				// If start time was changed and equals end time, set end time to start + 1 minute
				return { startTime, endTime: minutesToTimeString(startMinutes + 1) };
			} else {
				// If end time was changed and equals start time, set start time to end - 1 minute
				return { startTime: minutesToTimeString(endMinutes - 1), endTime };
			}
		}
		
		// Calculate time difference (handle day wrap-around)
		let timeDifference = endMinutes - startMinutes;
		if (timeDifference < 0) {
			timeDifference += 24 * 60; // Add 24 hours if end time is next day
		}
		
		// If end time is before start time (and not next day), adjust end time
		if (timeDifference <= 0) {
			if (changedField === 'startTime') {
				// Start time was changed, set end time to start + 1 minute
				return { startTime, endTime: minutesToTimeString(startMinutes + 1) };
			} else {
				// End time was changed, set start time to end - 1 minute
				return { startTime: minutesToTimeString(endMinutes - 1), endTime };
			}
		}
		
		// If time difference is more than 10 minutes, limit to 10 minutes
		if (timeDifference > 10) {
			if (changedField === 'startTime') {
				// Start time was changed, set end time to start + 10 minutes
				return { startTime, endTime: minutesToTimeString(startMinutes + 10) };
			} else {
				// End time was changed, set start time to end - 10 minutes
				return { startTime: minutesToTimeString(endMinutes - 10), endTime };
			}
		}
		
		// If time difference is exactly 10 minutes or less, return as is
		return { startTime, endTime };
	};

	// Handle SSE data updates
	const handleSSEData = React.useCallback((parsedData) => {
		console.log('SSE data received:', parsedData);

		// Basic shape guard
		if (!parsedData || !parsedData.data) {
			return;
		}

		const userData = parsedData.data[item.user_id];

		// If there's no entry for this user, or it's an empty array, do nothing
		if (
			!userData ||
			(Array.isArray(userData) && userData.length === 0)
		) {
			return;
		}

		// Only update state when we actually have data for this user
		setFData(parsedData.data);
	}, [item.user_id]);

	// Handle SSE errors
	const handleSSEError = React.useCallback((error) => {
		console.error('SSE Error:', error);
	}, []);

	// Use SSE hook
	useSSE(
		`user/data/${item.user_id}`,
		handleSSEData,
		handleSSEError
	);

	useEffect(() => {
		getData();
		getIndividualDataGraphData({
			date: selectedDate,
			startTime: initialStartTime,
			endTime: initialEndTime
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedDate, initialStartTime, initialEndTime]);

	const breadcrumbs = [
		<p key="dashboard" onClick={handleClick} className={styles.breadcrumbs}>
			Dashboard
		</p>,
		<p key="username" className={styles.breadcrumbs}>
			{location.state?.first_name}&nbsp; {location.state?.last_name}
		</p>,
	];

	if (fData.length === 0) {
		return <p>Please wait...</p>;
	}

	return (
		<div>
			<AddPrivateNote
				setOpen={setOpen}
				open={open}
				players_id={item?.user_id}
			/>
			<InsuranceStatementModal
				open={insuranceModalOpen}
				onClose={() => setInsuranceModalOpen(false)}
				initialStep={3}
				initialPatients={[insuranceStatementPatient]}
				hideSteps
			/>
			<div className={styles.container}>
				<div className={styles.tab}>
					<Breadcrumbs
						separator={<NavigateNextIcon fontSize="small" />}
						aria-label="breadcrumb"
					>
						{breadcrumbs}
					</Breadcrumbs>
				</div>
			</div>
			<div className={styles.container}>
				<div className={styles.header}>
					<div className={styles.inside}>
						<div className={styles.box}>
							<div className={styles.item2}>
								{' '}
								<Avatar
									alt={location.state?.first_name}
									src={location.state.avatar_url}
									sx={{ width: 46, height: 46 }}
								/>
							</div>
							<div className={styles.item3}>
								{' '}
								<p className={styles.tdText}>
									{' '}
									{location.state?.first_name}&nbsp; {location.state?.last_name}
								</p>
							</div>
						</div>
						<div className={styles.boxButton}>
							<div className={styles.item4}>
								<input
									type="button"
									className={styles.searchButton}
									value="Back"
									onClick={direct}
								/>
							</div>
							<div className={styles.item4}>
								<div className={styles.insuranceWrapper}>
									<button
										type="button"
										className={styles.insuranceButton}
										onClick={() => setInsuranceModalOpen(true)}
										disabled={daysUsed === 0}
									>
										Insurance Statement
									</button>
									<div className={styles.daysUsedRow}>
										{daysUsed !== 0 && <DaysUsedCheckIcon className={styles.daysUsedIcon} />}
										<span className={styles.daysUsedText}>
											<span>Days used:</span>
											<span>{insuranceStatement?.days_used_display ?? `${daysUsed}/${totalDaysAllowed}`}</span>
										</span>
									</div>
								</div>
							</div>
							<div className={styles.item4}>
								<Button
									fullWidth
									size="large"
									style={{
										fontSize: '0.87rem',
										fontFamily: '"Poppins", sans-serif',
										fontWeight: 500,
										fontStyle: 'normal',
										width: 120,
										height: 32,
										backgroundColor: '#197F8F',
										color: 'white',
										textTransform: 'none',
									}}
									startIcon={<EditIconTakeNote />}
									onClick={() => setOpen(true)}
								>
									Take notes
								</Button>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* Health */}
			<div className={styles.container}>
				<div className={styles.container2}>
					<div className={styles.healthPanel}>
						<hr className={styles.dividerTop} />
						<p className={`${styles.tdText} ${styles.sectionTitleGap}`}>{'Health'}</p>
						<div className={styles.boxNew}>
							<SingleVital
								fData={fData}
								item={item}
								Icon={OxygenIcon}
								title="Oxygen"
								subTitle="SPO₂"
								field="spo2"
							/>
							<SingleVital
								fData={fData}
								item={item}
								Icon={HeartIcon}
								title="Pulse Rate"
								subTitle="bpm"
								field="heart_rate"
							/>

							{/*  Commented out for demo purposes */}
							{/* <SingleVital
								fData={fData}
								item={item}
								Icon={SPOIcon}
								title="SPO₂ Variability"
								subTitle="mL/s"
								field="spv"
							/> */}

							{/* <SingleVital
								fData={fData}
								item={item}
								Icon={PerfusionIcon}
								title="Perfusion Index"
								subTitle="%"
								field="pi"
							/> */}
							{/* <SingleVital
								fData={fData}
								item={item}
								Icon={HRVIcon}
								title="PRV"
								subTitle="ms"
								field="hrv"
							/> */}
							{/* TODO */}
						</div>
						<div className={styles.boxNew}>

							{/*  Commented out for demo purposes */}
							{/* <SingleVital
								fData={fData}
								item={item}
								Icon={HRRIcon}
								title="PRR"
								subTitle="%"
								field="hrr"
							/> */}
							{/* <SingleVital
                fData={fData}
                item={item}
                Icon={AvgO2}
                title="Ave VO2"
                subTitle="mL/kg/min"
                field="hrv"
              />
              <SingleVital
                fData={fData}
                item={item}
                Icon={MaxO2}
                title="Max VO2"
                subTitle="mL/kg/min"
                field="hrv"
              /> */}
						</div>
					</div>
				</div>
			</div>
			{/* Environment */}
			<div className={styles.container}>
				<div className={styles.container2}>
					<div className={styles.environmentPanel}>
						<p className={`${styles.tdText} ${styles.sectionTitleGap}`}>{'Environment'}</p>
						<div className={styles.boxNew}>
							{/* <SingleVital
								fData={fData}
								item={item}
								Icon={TempatureIcon}
								title="Temperature"
								subTitle="°F"
								field="temp"
							/> */}

							<SingleVital
								fData={fData}
								item={item}
								Icon={AltitudeIcon}
								title="Altitude"
								subTitle="feet"
								field="altitude"
							/>

							<SingleVital
								fData={fData}
								item={item}
								Icon={AirQualityIcon}
								title="Air Quality Index"
								subTitle="moderate"
								field="air_quality"
							/>

							<SingleVital
								fData={fData}
								item={item}
								Icon={HumidityIcon}
								title="Humidity"
								subTitle="%"
								field="humidity"
							/>

							<SingleVital
								fData={fData}
								item={item}
								Icon={BarometricIcon}
								title="Barometric Pressure"
								subTitle="in. HG"
								field="biometric_pressure"
							/>
						</div>
					</div>
				</div>
			</div>
			<div className={styles.container}>
				<div className={styles.container3}>
					<div className={styles.chartPanel}>
						{/* <p className={styles.tdText}>{'Live Reading**'}</p> */}
						<hr className={styles.sectionDivider} />
						
						{/* Date and Time Selection */}
						<Formik
							initialValues={{
								selectedDate: selectedDate,
								startTime: initialStartTime,
								endTime: initialEndTime
							}}
							enableReinitialize
							onSubmit={async (values) => {
								// Validate and adjust times to ensure proper ordering and 10-minute limit
								const { startTime, endTime } = validateAndAdjustTimes(values.startTime, values.endTime, 'submit');
								
								const apiData = {
									startTime,
									endTime,
									date: values.selectedDate
								};

								getIndividualDataGraphData(apiData);
							}}
						>
							{({ errors, touched, values, setFieldValue, submitForm }) => (
								<Form>
									<div className={styles.timeFormRow}>
										{/* Date Field */}
										<div className={styles.timeFieldContainer}>
											<Typography className={styles.timeLabel}>
												Date
											</Typography>
											<Field
												name="selectedDate"
												type="date"
												className={styles.timeInput}
												onChange={(e) => {
													setFieldValue('selectedDate', e.target.value);
													setSelectedDate(e.target.value);
													submitForm();
												}}
											/>
											{errors.selectedDate && touched.selectedDate && (
												<div className={styles.timeErrorMessage}>
													{errors.selectedDate}
												</div>
											)}
										</div>

										{/* Start Time Field */}
										<div className={styles.timeFieldContainer}>
											<Typography className={styles.timeLabel}>
												Start Time
											</Typography>
											<Field
												name="startTime"
												type="time"
												step="1"
												className={styles.timeInput}
												onChange={(e) => {
													const selectedStartTime = e.target.value;
													
													// Validate and adjust both times based on start time change
													const { startTime, endTime } = validateAndAdjustTimes(selectedStartTime, values.endTime, 'startTime');
													
													setFieldValue('startTime', startTime);
													setFieldValue('endTime', endTime);
													
													submitForm();
												}}
											/>
											{errors.startTime && touched.startTime && (
												<div className={styles.timeErrorMessage}>
													{errors.startTime}
												</div>
											)}
										</div>

										{/* End Time Field */}
										<div className={styles.timeFieldContainer}>
											<Typography className={styles.timeLabel}>End Time</Typography>
											<Field
												name="endTime"
												type="time"
												step="1"
												className={styles.timeInput}
												onChange={(e) => {
													const selectedEndTime = e.target.value;
													
													// Validate and adjust both times based on end time change
													const { startTime, endTime } = validateAndAdjustTimes(values.startTime, selectedEndTime, 'endTime');
													
													setFieldValue('startTime', startTime);
													setFieldValue('endTime', endTime);
													
													submitForm();
												}}
											/>
											{errors.endTime && touched.endTime && (
												<div className={styles.timeErrorMessage}>
													{errors.endTime}
												</div>
											)}
										</div>
									</div>
									<div className={styles.timeHelpText}>
										<InfoIcon className={styles.timeHelpIcon} />
										<span>End time must be after start time. Maximum range: 10 minutes</span>
									</div>
								</Form>
							)}
						</Formik>
						<div className={styles.chPartLegend}>
							<div className={styles.legendItem}>
								<div className={styles.legendLineSolid}></div>
								<p className={styles.tittleText}>SpO₂ (%)</p>
							</div>
							<div className={styles.legendItem}>
								<div className={styles.legendLineDashed}></div>
								<p className={styles.tittleText}>Pulse Rate (bpm)</p>
							</div>
						</div>
					{isLoadingGraphData ? (
						<div className={styles.chartLoading}>
							Loading chart data...
						</div>
					) : graphDataError ? (
						<div className={styles.chartError}>
							{graphDataError}
						</div>
					) : userGraphData && userGraphData[item?.user_id] && userGraphData[item?.user_id].length > 0 ? (
                            // <Line options={options} data={userGraphData[item?.user_id]} />
						<IndividualViewChart fData={userGraphData[item?.user_id]} height={300} />
					) : (
						<div className={styles.chartEmpty}>
							No data available for the selected time range
						</div>
					)}

						
					</div>
				</div>
			</div>
		</div>
	);
}
